<template>
  <div
    :style="
      'background-image: url(' +
        (megaImageCopy ? megaImageCopy : logoLight) +
        ')'
    "
    class="mega_image"
    :class="{ filler_detail_image: !megaImageCopy }"
  >
    <!-- <section class="detail_images">
      <div>
        <img height="100%" :src="megaImage" />
      </div>
    </section>-->

    <a
      href
      class="close_button round light ml-2 mt-2"
      @click.prevent="cleverBackToList()"
    ></a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MegaImage",
  data() {
    return {
      megaImageCopy: ""
    };
  },
  props: ["megaImage", "productType"],
  computed: {
    ...mapGetters(["logoLight"])
  },
  watch: {
    megaImage: {
      handler() {
        //alert("megaImage: " + this.megaImage);
        if (this.megaImage) {
          this.megaImageCopy = this.megaImage;
        }
      },
      immediate: true
    }
  },
  methods: {
    //...mapActions(["closeDetailComponent"])
    cleverBackToList() {
      this.$emit("cleverBackToList", {});
    }
  }
};
</script>

<style></style>
